import { render, staticRenderFns } from "./laf.vue?vue&type=template&id=608b6078&scoped=true"
import script from "./laf.vue?vue&type=script&lang=ts&setup=true"
export * from "./laf.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./laf.vue?vue&type=style&index=0&id=608b6078&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608b6078",
  null
  
)

export default component.exports